// extracted by mini-css-extract-plugin
export default {"wrapper":"attachment-wrapper_wrapper__AfpbU","button":"attachment-wrapper_button__awi+x"};